module.exports = __webpack_public_path__ + "static/media/news-press-j.3013c454.png";